/* ============================================================
   DFA — dfa-produit.js
   <dfa-produit-form> : sélection de variantes en pastilles,
   prix/dispo synchronisés, ruptures barrées (jamais cachées),
   galerie liée à la variante, lueur d'encoche par couleur.
   Vanilla · defer · cleanup en disconnectedCallback.
   ============================================================ */
(function () {
  'use strict';

  class DfaProduitForm extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-variants]');
      if (!dataEl) return;
      this.variants = JSON.parse(dataEl.textContent);
      this.section = this.closest('.dfa-produit');
      this.idInput = this.querySelector('[data-variant-id]');
      this.prixCourant = this.querySelector('[data-prix-courant]');
      this.prixBarre = this.querySelector('[data-prix-barre]');
      this.bouton = this.querySelector('[data-bouton-achat]');
      this.libelles = {
        achat: this.bouton ? this.bouton.dataset.libelleAchat : 'Ajouter au panier',
        rupture: this.bouton ? this.bouton.dataset.libelleRupture : 'Rupture de stock',
        indisponible: this.bouton ? this.bouton.dataset.libelleIndisponible : 'Indisponible'
      };
      this._onChange = this.handleChange.bind(this);
      this._onVignette = this.handleVignette.bind(this);
      this.addEventListener('change', this._onChange, { passive: true });
      if (this.section) this.section.addEventListener('click', this._onVignette, { passive: true });
      this.majDisponibilites();
      this.majLueur();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
      if (this.section) this.section.removeEventListener('click', this._onVignette);
    }

    get optionsChoisies() {
      var valeurs = [];
      this.querySelectorAll('[data-option-fieldset]').forEach(function (fs) {
        var coche = fs.querySelector('input:checked');
        valeurs.push(coche ? coche.value : null);
      });
      return valeurs;
    }

    trouverVariante(options) {
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }

    handleChange(e) {
      if (!e.target.matches('[data-option-input]')) return;
      var choisies = this.optionsChoisies;
      var v = this.trouverVariante(choisies);

      // Libellé de la valeur choisie à côté du nom d'option
      var fs = e.target.closest('[data-option-fieldset]');
      var choix = fs ? fs.querySelector('[data-option-choix]') : null;
      if (choix) choix.textContent = e.target.value;

      if (v) {
        if (this.idInput) this.idInput.value = v.id;
        if (this.prixCourant) this.prixCourant.textContent = v.price;
        if (this.prixBarre) {
          if (v.compare) { this.prixBarre.textContent = v.compare; this.prixBarre.hidden = false; }
          else { this.prixBarre.textContent = ''; this.prixBarre.hidden = true; }
        }
        if (this.bouton) {
          this.bouton.disabled = !v.available;
          this.bouton.textContent = v.available ? this.libelles.achat : this.libelles.rupture;
        }
        if (v.media) this.activerMedia(v.media);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else if (this.bouton) {
        this.bouton.disabled = true;
        this.bouton.textContent = this.libelles.indisponible;
      }

      this.majDisponibilites();
      this.majLueur();
    }

    /* Ruptures : pour chaque valeur, existe-t-il une variante dispo
       compatible avec les options PRÉCÉDENTES choisies? Sinon → barrée. */
    majDisponibilites() {
      var self = this;
      var choisies = this.optionsChoisies;
      this.querySelectorAll('[data-option-fieldset]').forEach(function (fs, index) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          var dispo = self.variants.some(function (v) {
            if (v.options[index] !== input.value || !v.available) return false;
            for (var j = 0; j < index; j++) {
              if (choisies[j] !== null && v.options[j] !== choisies[j]) return false;
            }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-indisponible', !dispo);
        });
      });
    }

    /* Lueur d'encoche : suit l'option « Couleur » (produits lumineux seulement) */
    majLueur() {
      if (!this.section || !this.section.hasAttribute('data-glow-enabled')) return;
      var fs = Array.prototype.find.call(
        this.querySelectorAll('[data-option-fieldset]'),
        function (f) { return (f.dataset.optionName || '').toLowerCase().indexOf('couleur') !== -1; }
      );
      if (!fs) return;
      var coche = fs.querySelector('input:checked');
      if (coche) this.section.dataset.glow = coche.value.toLowerCase();
    }

    activerMedia(mediaId) {
      if (!this.section) return;
      this.section.querySelectorAll('[data-media-id]').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.mediaId === String(mediaId));
      });
      this.section.querySelectorAll('[data-vignette]').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.vignette === String(mediaId));
      });
    }

    handleVignette(e) {
      var vignette = e.target.closest('[data-vignette]');
      if (vignette) this.activerMedia(vignette.dataset.vignette);
    }
  }

  if (!customElements.get('dfa-produit-form')) {
    customElements.define('dfa-produit-form', DfaProduitForm);
  }
})();

